// extracted by mini-css-extract-plugin
module.exports = {"paywall":"Paywall_paywall__KUReC","paywall__text":"Paywall_paywall__text__NSKD4","paywall__noCnpjButton":"Paywall_paywall__noCnpjButton__oxIPQ"};